// src/components/Gallery.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactPlayer from 'react-player';
import './Gallery.css';

const API_KEY = 'AIzaSyAsIkemre8E376xBAE_bBZlgRlbtqWhIPA'; // Replace with your API key
const CHANNEL_ID = 'UCFcKlA6WzJGPF0M3ika-Bmw';
const MAX_RESULTS = 8;
const CACHE_DURATION_MS = 1000 * 60 * 60 * 2; // 2 hours

function Gallery() {
  const [videos, setVideos] = useState([]);
  const [nextPageToken, setNextPageToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState('');

  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

  const cacheKey = 'galleryCache';

  const cacheVideos = (videos, token) => {
    const cache = {
      videos,
      token,
      timestamp: new Date().getTime(),
    };
    localStorage.setItem(cacheKey, JSON.stringify(cache));
  };

  const fetchVideos = async (pageToken = '') => {
    if (loading) return; // ⛔ prevent duplicate fetches
    setLoading(true);
    setError('');

    try {
      const res = await axios.get('https://www.googleapis.com/youtube/v3/search', {
        params: {
          key: API_KEY,
          channelId: CHANNEL_ID,
          part: 'snippet',
          order: 'date',
          maxResults: MAX_RESULTS,
          pageToken,
        },
      });

      const newVideos = res.data.items
        .filter(item => item.id.kind === 'youtube#video')
        .filter(item => new Date(item.snippet.publishedAt) >= twoWeeksAgo);

      setVideos(prev => {
        const existingIds = new Set(prev.map(v => v.id.videoId));
        const filteredNew = newVideos.filter(v => !existingIds.has(v.id.videoId));
        const updated = [...prev, ...filteredNew];

        // Cache only if new videos are added
        if (filteredNew.length > 0) {
          cacheVideos(updated, res.data.nextPageToken || '');
        }

        return updated;
      });

      setNextPageToken(res.data.nextPageToken || '');
      setHasMore(!!res.data.nextPageToken && newVideos.length > 0);

    } catch (err) {
      console.error('Failed to fetch videos', err);
      setError(err.response?.status === 403
        ? 'Unable to load videos at this time. Please try again later.'
        : '⚠️ Something went wrong while fetching videos.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const cached = localStorage.getItem(cacheKey);
    const now = new Date().getTime();

    if (cached) {
      const { videos, token, timestamp } = JSON.parse(cached);
      if (now - timestamp < CACHE_DURATION_MS) {
        setVideos(videos);
        setNextPageToken(token || '');
        setHasMore(!!token);
        return;
      }
    }

    fetchVideos();
  }, []);

  return (
    <div>
      <br />
      <h2 className="text-center">Videos</h2>
      <br />

      {error && (
        <div className="text-center text-red-600 mb-4">
          {error}
        </div>
      )}

      <div className="video-grid">
        {videos.length === 0 && !error && !loading && (
          <div className="text-center">No videos available.</div>
        )}
        {videos.map(video => (
          <div className="video-card" key={video.id.videoId}>
            <div className="player-wrapper" style={{ position: 'relative', paddingTop: '56.25%' }}>
              <ReactPlayer
                url={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                controls
                width="100%"
                height="100%"
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>
            <p>{video.snippet.title}</p>
          </div>
        ))}
      </div>

      {hasMore && !error && (
        <div className="text-center mt-4">
          <button
            onClick={() => fetchVideos(nextPageToken)}
            className="bg-pink-600 text-black px-4 py-2 rounded hover:bg-pink-700"
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </div>
  );
}

export default Gallery;
